import { render, staticRenderFns } from "./LoginBar.vue?vue&type=template&id=3bddb40e&scoped=true"
import script from "./LoginBar.vue?vue&type=script&lang=js"
export * from "./LoginBar.vue?vue&type=script&lang=js"
import style0 from "./LoginBar.vue?vue&type=style&index=0&id=3bddb40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddb40e",
  null
  
)

export default component.exports